





















































import {Vue, Component} from 'vue-property-decorator';
import dataProxy from '@/services/data-proxy.service';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDateTime, formatInteger} from "@/utils/formatters";
import * as _ from 'lodash'

@Component
export default class PregledKretanjaVozila extends mixins(ComponentBaseMixin) {
    odDatuma: Date = new Date();
    doDatuma: Date = new Date();
    vozac = '';
    isBusy = false;
    dataSource = [];
    tableOptions = {
        pagination: true,
        showFooter: true,
        showColumns: true,
        footerStyle() {
            return {
                css: {
                    'font-weight': 'bold'
                }
            }
        }
    };
    columns = [];
    filterVisible = false;
    get postavljenFilter() {
        return this.odDatuma && this.doDatuma && this.vozac;
    }

    created() {
        this.columns = [
            {field: 'vozilo', title: this.$i18n.t('vozilo'), width: 140},
            {field: 'vremePolaska', title: this.$i18n.t('vremePolaska'), formatter: formatDateTime, width: 160},
            {field: 'mestoPolaska', title: this.$i18n.t('mestoPolaska')},
            {field: 'vremeDolaska', title: this.$i18n.t('vremeDolaska'), formatter: formatDateTime, width: 160},
            {field: 'mestoDolaska', title: this.$i18n.t('mestoDolaska'),},
            {field: 'kilometrazaPolaska', title: this.$i18n.t('pocetnaKM'), formatter: formatInteger, width: 120, align: 'right'},
            {field: 'kilometrazaDolaska', title: this.$i18n.t('krajnjaKilometraza'), formatter: formatInteger, width: 120, align: 'right', footerFormatter: this.$i18n.t('ukupno')},
            {field: 'predjeno', title: this.$i18n.t('predjenaKilometraza'), formatter: formatInteger, width: 120, align: 'right', footerFormatter: (items) => formatInteger(_.sumBy(items, 'predjeno'))},
        ];
    }

    async pretrazi() {
        if (this.isBusy) return;
        try {
            this.isBusy = true;
            this.dataSource = await this.loadData(() => dataProxy.vratiPregledKretanjaVozaca(this.odDatuma, this.doDatuma, +this.vozac))();
        } finally {
            this.isBusy = false;
        }

    }

    toggleFilter() {
        this.filterVisible = !this.filterVisible;
    }
}
